(function () {
  function moveSizeChartLink(productSection) {
    var sizeLabel = productSection.querySelector('.variant__label--size-buttons');
    if (!sizeLabel) return false;

    var sizeWrapper = sizeLabel.closest('.variant-wrapper--size-buttons');
    var sizeChartText = sizeWrapper.dataset.sizeChartText.trim().toLowerCase();

    var candidates = productSection.querySelectorAll('a, button, [role="button"]');
    for (var i = 0; i < candidates.length; i += 1) {
      var candidate = candidates[i];
      var text = candidate.textContent.trim().replace(/\s+/g, ' ').toLowerCase();

      if (text !== sizeChartText) continue;
      if (sizeLabel.contains(candidate)) return true;

      candidate.classList.add('kiwi-size-chart-link');
      sizeLabel.appendChild(candidate);
      return true;
    }

    return false;
  }

  function initialiseProductPickers(root) {
    var productSections = root.querySelectorAll
      ? root.querySelectorAll('.product-section')
      : [];

    for (var i = 0; i < productSections.length; i += 1) {
      if (moveSizeChartLink(productSections[i])) return true;
    }

    return false;
  }

  document.addEventListener('DOMContentLoaded', function () {
    if (initialiseProductPickers(document)) return;

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i += 1) {
        if (mutations[i].addedNodes.length && initialiseProductPickers(document)) {
          observer.disconnect();
          break;
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
    window.setTimeout(function () { observer.disconnect(); }, 15000);
  });
})();
